import { useRef, useEffect } from 'react';
const useTabTrap = () => {
    const ref = useRef();
    const handleTabPress = (e) => {
        if (!ref || !ref.current || e.keyCode !== 9)
            return;
        const focusableElements = ref.current.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];
        if (!ref.current.contains(document.activeElement)) {
            firstFocusable.focus();
        }
        if (!e.shiftKey && document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
            return;
        }
        if (e.shiftKey && document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
        }
    };
    useEffect(() => {
        window.addEventListener('keydown', handleTabPress);
        return () => window.removeEventListener('keydown', handleTabPress);
    });
    return ref;
};
export default useTabTrap;
//# sourceMappingURL=index.js.map